<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo-sm.svg" alt="" height="24" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-sm.svg" alt="" height="24" />
            <span class="logo-txt">Flow Sales</span>
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logo-sm.svg" alt="" height="24" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-sm.svg" alt="" height="24" />
            <span class="logo-txt">Flow Sales</span>
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <div class="d-flex">
      <div class="dropdown d-none d-sm-inline-block">
        <button type="button" class="btn header-item" id="mode-setting-btn">
          @if (layoutMode == "light") {
            <ng-container>
              <i-feather
                name="moon"
                class="feather-grid icon-lg"
                (click)="changeMode('dark')"
              ></i-feather>
            </ng-container>
          }
          @if (layoutMode == "dark") {
            <ng-container>
              <i-feather
                name="sun"
                class="feather-grid icon-lg"
                (click)="changeMode('light')"
              ></i-feather>
            </ng-container>
          }
        </button>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item noti-icon position-relative"
          id="page-header-notifications-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <i-feather name="bell" class="feather-grid icon-lg"></i-feather>
          <span class="badge bg-danger rounded-pill">5</span>
        </button>
        <div
          class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-notifications-dropdown"
          ngbDropdownMenu
        >
          <!-- <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">Últimas mensagens</h6>
              </div>
              <div class="col-auto">
                <a
                  href="javascript:void(0);"
                  class="small text-reset text-decoration-underline"
                >
                  Ver todas
                </a>
              </div>
            </div>
          </div> -->
          <!-- <ngx-simplebar style="max-height: 230px">
            <a href="javascript:void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <div class="flex-shrink-0 me-3">
                  <img
                    src="assets/images/users/avatar-3.jpg"
                    class="rounded-circle avatar-sm"
                    alt="user-pic"
                  />
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1">
                    {{ "HEADER.NOTIFICATIONS.FIRST.TITLE" | translate }}
                  </h6>
                  <div class="font-size-13 text-muted">
                    <p class="mb-1">
                      {{ "HEADER.NOTIFICATIONS.FIRST.TEXT" | translate }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      <span>
                        {{ "HEADER.NOTIFICATIONS.FIRST.TIME" | translate }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </ngx-simplebar> -->

          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              <span>Estamos Trabalhando</span>
            </a>
          </div>
        </div>
      </div>

      <!-- <div class="dropdown d-inline-block">
        <button
          type="button"
          class="btn header-item right-bar-toggle me-2"
          (click)="toggleRightSidebar()"
        >
          <i-feather name="settings" class="icon-lg"></i-feather>
        </button>
      </div> -->

      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item noti-icon position-relative"
          id="page-header-user-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <i-feather name="user" class="feather-grid icon-lg"></i-feather>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" routerLink="/my-profile">
            <i class="mdi mdi-face-man font-size-16 align-middle me-1"></i>
            Meu Perfil
          </a>
          <div class="dropdown-divider"></div>
          <a
            class="dropdown-item"
            href="javascript: void(0);"
            (click)="logout()"
          >
            <i
              class="mdi mdi-logout text-muted font-size-16 align-middle me-1"
            ></i>
            <span class="align-middle" key="t-logout">Sair</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</header>
